import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { surveyUrlSelector } from '@store/models/surveyWidget/selectors';
const Survey = () => {
    const url = useSelector(surveyUrlSelector);
    return (_jsx(_Fragment, { children: _jsx("iframe", { style: { border: 'none' }, src: url, width: "100%", height: "450" }) }));
};
export default Survey;
